function PlanT({ ...props }) {
	return (
		<g id="plan-t">
			<g id="furniture">
				<polyline
					points="713.41 916.44 713.41 918.96 708.44 918.96 708.44 916.44 713.41 916.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="234.46"
					y1="417.44"
					x2="345.03"
					y2="417.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.46"
					y1="543.92"
					x2="234.46"
					y2="417.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.8"
					y1="543.92"
					x2="231.94"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="543.92"
					x2="231.94"
					y2="539.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="535.6"
					x2="231.94"
					y2="529.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="525.94"
					x2="231.94"
					y2="519.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="516.27"
					x2="231.94"
					y2="510.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="506.61"
					x2="231.94"
					y2="500.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="496.94"
					x2="231.94"
					y2="490.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="487.28"
					x2="231.94"
					y2="481.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="477.61"
					x2="231.94"
					y2="471.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="467.95"
					x2="231.94"
					y2="461.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="458.28"
					x2="231.94"
					y2="452.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="448.61"
					x2="231.94"
					y2="442.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="438.95"
					x2="231.94"
					y2="432.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="429.28"
					x2="231.94"
					y2="423.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="419.62"
					x2="231.94"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.94"
					y1="414.93"
					x2="233.81"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.14"
					y1="414.93"
					x2="243.18"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.8"
					y1="414.93"
					x2="252.84"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.47"
					y1="414.93"
					x2="262.51"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.13"
					y1="414.93"
					x2="272.17"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.8"
					y1="414.93"
					x2="281.84"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.46"
					y1="414.93"
					x2="291.51"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.13"
					y1="414.93"
					x2="301.17"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.79"
					y1="414.93"
					x2="310.84"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.46"
					y1="414.93"
					x2="320.5"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.12"
					y1="414.93"
					x2="330.17"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.79"
					y1="414.93"
					x2="339.83"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.15"
					y1="414.93"
					x2="345.03"
					y2="414.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="414.93"
					x2="345.03"
					y2="408.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="358.58 844.64 358.58 912.6 290.62 912.6 290.62 844.64 358.58 844.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="735.21 54.04 693.8 54.04 693.8 59.49 735.21 59.49 735.21 54.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="691.82 53.55 737.19 53.55 737.19 54.04 691.82 54.04 691.82 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="691.82"
					y1="53.55"
					x2="737.19"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="53.55"
					x2="737.19"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="54.04"
					x2="691.82"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.82"
					y1="54.04"
					x2="691.82"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.21"
					y1="59.49"
					x2="693.8"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.8"
					y1="54.04"
					x2="735.21"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="739.67 59.49 735.21 59.49 735.21 54.04 739.67 54.04 739.67 59.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.67"
					y1="59.49"
					x2="735.21"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.21"
					y1="59.49"
					x2="735.21"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.21"
					y1="54.04"
					x2="739.67"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.67"
					y1="54.04"
					x2="739.67"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="689.34 54.04 693.8 54.04 693.8 59.49 689.34 59.49 689.34 54.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="689.34"
					y1="54.04"
					x2="693.8"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.8"
					y1="54.04"
					x2="693.8"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.8"
					y1="59.49"
					x2="689.34"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.34"
					y1="59.49"
					x2="689.34"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.21"
					y1="55.03"
					x2="693.8"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.65 59 739.67 59 739.67 54.04 737.19 54.04 737.19 53.55 741.65 53.55 741.65 59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="741.65"
					y1="59"
					x2="739.67"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.67"
					y1="59"
					x2="739.67"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.67"
					y1="54.04"
					x2="737.19"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="54.04"
					x2="737.19"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="53.55"
					x2="741.65"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.65"
					y1="53.55"
					x2="741.65"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="687.36 53.55 691.82 53.55 691.82 54.04 689.34 54.04 689.34 59 687.36 59 687.36 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="687.36"
					y1="53.55"
					x2="691.82"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.82"
					y1="53.55"
					x2="691.82"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.82"
					y1="54.04"
					x2="689.34"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.34"
					y1="54.04"
					x2="689.34"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.34"
					y1="59"
					x2="687.36"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.36"
					y1="59"
					x2="687.36"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="684.84 55.03 684.84 57.55 583.12 57.55 583.12 55.03 684.84 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="684.84"
					y1="55.03"
					x2="684.84"
					y2="57.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.84"
					y1="57.55"
					x2="583.12"
					y2="57.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.12"
					y1="57.55"
					x2="583.12"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.12"
					y1="55.03"
					x2="684.84"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.65 55.03 746.68 55.03 746.68 70.14 741.65 70.14 741.65 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="746.68"
					y1="55.03"
					x2="741.65"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.68"
					y1="70.14"
					x2="746.68"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.65"
					y1="70.14"
					x2="746.68"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.65"
					y1="55.03"
					x2="741.65"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="682.32 55.03 687.36 55.03 687.36 70.14 682.32 70.14 682.32 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="687.36"
					y1="55.03"
					x2="682.32"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.36"
					y1="70.14"
					x2="687.36"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.32"
					y1="70.14"
					x2="687.36"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.32"
					y1="55.03"
					x2="682.32"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="580.6 55.03 585.63 55.03 585.63 70.14 580.6 70.14 580.6 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="585.63"
					y1="55.03"
					x2="580.6"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.63"
					y1="70.14"
					x2="585.63"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.6"
					y1="70.14"
					x2="585.63"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.6"
					y1="55.03"
					x2="580.6"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="430.53 54.04 389.12 54.04 389.12 59.49 430.53 59.49 430.53 54.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="387.14 53.55 432.51 53.55 432.51 54.04 387.14 54.04 387.14 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="387.14"
					y1="53.55"
					x2="432.51"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.51"
					y1="53.55"
					x2="432.51"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.51"
					y1="54.04"
					x2="387.14"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.14"
					y1="54.04"
					x2="387.14"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.53"
					y1="59.49"
					x2="389.12"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.12"
					y1="54.04"
					x2="430.53"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="434.99 59.49 430.53 59.49 430.53 54.04 434.99 54.04 434.99 59.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="434.99"
					y1="59.49"
					x2="430.53"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.53"
					y1="59.49"
					x2="430.53"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.53"
					y1="54.04"
					x2="434.99"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.99"
					y1="54.04"
					x2="434.99"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="384.66 54.04 389.12 54.04 389.12 59.49 384.66 59.49 384.66 54.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="384.66"
					y1="54.04"
					x2="389.12"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.12"
					y1="54.04"
					x2="389.12"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.12"
					y1="59.49"
					x2="384.66"
					y2="59.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="59.49"
					x2="384.66"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.53"
					y1="55.03"
					x2="389.12"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="436.97 59 434.99 59 434.99 54.04 432.51 54.04 432.51 53.55 436.97 53.55 436.97 59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="436.97"
					y1="59"
					x2="434.99"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.99"
					y1="59"
					x2="434.99"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.99"
					y1="54.04"
					x2="432.51"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.51"
					y1="54.04"
					x2="432.51"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.51"
					y1="53.55"
					x2="436.97"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.97"
					y1="53.55"
					x2="436.97"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="382.68 53.55 387.14 53.55 387.14 54.04 384.66 54.04 384.66 59 382.68 59 382.68 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="382.68"
					y1="53.55"
					x2="387.14"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.14"
					y1="53.55"
					x2="387.14"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.14"
					y1="54.04"
					x2="384.66"
					y2="54.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="54.04"
					x2="384.66"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="59"
					x2="382.68"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.68"
					y1="59"
					x2="382.68"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="380.16 55.03 380.16 57.55 247.93 57.55 247.93 55.03 380.16 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="380.16"
					y1="55.03"
					x2="380.16"
					y2="57.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.16"
					y1="57.55"
					x2="247.93"
					y2="57.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.93"
					y1="57.55"
					x2="247.93"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.93"
					y1="55.03"
					x2="380.16"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="436.97 55.03 442 55.03 442 70.14 436.97 70.14 436.97 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="442"
					y1="55.03"
					x2="436.97"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442"
					y1="70.14"
					x2="442"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.97"
					y1="70.14"
					x2="442"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.97"
					y1="55.03"
					x2="436.97"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="377.64 55.03 382.68 55.03 382.68 70.14 377.64 70.14 377.64 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="382.68"
					y1="55.03"
					x2="377.64"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.68"
					y1="70.14"
					x2="382.68"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.64"
					y1="70.14"
					x2="382.68"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.64"
					y1="55.03"
					x2="377.64"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="245.41 55.03 250.45 55.03 250.45 70.14 245.41 70.14 245.41 55.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="250.45"
					y1="55.03"
					x2="245.41"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.45"
					y1="70.14"
					x2="250.45"
					y2="55.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.41"
					y1="70.14"
					x2="250.45"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.41"
					y1="55.03"
					x2="245.41"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.33"
					y1="948.74"
					x2="385.55"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="385.55"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="389.33"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="948.74"
					x2="488.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="488.75"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="484.98"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="378.25"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="483.72 950 488.75 950 488.75 948.74 483.72 948.74 483.72 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="390.59 948.74 385.55 948.74 385.55 950 390.59 950 390.59 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="483.72 928.61 488.75 928.61 488.75 927.35 483.72 927.35 483.72 928.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="390.59 927.35 385.55 927.35 385.55 928.61 390.59 928.61 390.59 927.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="483.72"
					y1="950"
					x2="488.75"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.75"
					y1="950"
					x2="488.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.75"
					y1="948.74"
					x2="483.72"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.72"
					y1="948.74"
					x2="483.72"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.59"
					y1="948.74"
					x2="385.55"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.55"
					y1="948.74"
					x2="385.55"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.55"
					y1="950"
					x2="390.59"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.59"
					y1="950"
					x2="390.59"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.72"
					y1="928.61"
					x2="488.75"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.75"
					y1="928.61"
					x2="488.75"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.75"
					y1="927.35"
					x2="483.72"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.72"
					y1="927.35"
					x2="483.72"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.59"
					y1="927.35"
					x2="385.55"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.55"
					y1="927.35"
					x2="385.55"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.55"
					y1="928.61"
					x2="390.59"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.59"
					y1="928.61"
					x2="390.59"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="482.46 948.74 484.34 948.74 484.34 928.61 482.46 928.61 482.46 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="389.96 948.74 391.85 948.74 391.85 928.61 389.96 928.61 389.96 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="455.92 864.54 391.85 928.61 394.96 931.72 459.03 867.65 455.92 864.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="484.34"
					y1="928.61"
					x2="484.98"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.34"
					y1="948.74"
					x2="484.98"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="484.98"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.96"
					y1="928.61"
					x2="389.33"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.96"
					y1="948.74"
					x2="389.33"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="389.33"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.46"
					y1="948.74"
					x2="482.46"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.46"
					y1="928.61"
					x2="484.34"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.34"
					y1="928.61"
					x2="484.34"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.34"
					y1="948.74"
					x2="482.46"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.96"
					y1="948.74"
					x2="389.96"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.96"
					y1="928.61"
					x2="391.85"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.85"
					y1="928.61"
					x2="391.85"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.85"
					y1="948.74"
					x2="389.96"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.92"
					y1="864.54"
					x2="459.03"
					y2="867.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.03"
					y1="867.65"
					x2="394.96"
					y2="931.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.96"
					y1="931.72"
					x2="391.85"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.85"
					y1="928.61"
					x2="455.92"
					y2="864.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="484.98"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="484.98"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="488.75"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="928.61"
					x2="488.75"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="948.74"
					x2="488.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="484.98"
					y1="948.74"
					x2="488.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="389.33"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="389.33"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="385.55"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="928.61"
					x2="385.55"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="948.74"
					x2="385.55"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="389.33"
					y1="948.74"
					x2="385.55"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="283.94"
					y1="792.48"
					x2="263.8"
					y2="792.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="263.8"
					y1="792.48"
					x2="212.9"
					y2="792.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="212.9"
					y1="792.48"
					x2="212.9"
					y2="711.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.41"
					y1="50"
					x2="245.41"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="781.5"
					y1="845.97"
					x2="801.64"
					y2="845.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="801.64"
					y1="845.97"
					x2="807.41"
					y2="845.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="827.55"
					y1="825.83"
					x2="801.64"
					y2="825.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="827.55"
					y1="825.83"
					x2="827.55"
					y2="845.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="556.5"
					x2="481.09"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="481.09"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="477.32"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="556.5"
					x2="393"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="393"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="396.78"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.69"
					y1="543.92"
					x2="519.69"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="556.5"
					x2="604.01"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="604.01"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="600.23"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="398.03 557.76 398.03 556.5 393 556.5 393 557.76 398.03 557.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="476.06 556.5 476.06 557.76 481.09 557.76 481.09 556.5 476.06 556.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="398.03 543.92 398.03 542.66 393 542.66 393 543.92 398.03 543.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="476.06 542.66 476.06 543.92 481.09 543.92 481.09 542.66 476.06 542.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="398.03"
					y1="557.76"
					x2="393"
					y2="557.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393"
					y1="557.76"
					x2="393"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393"
					y1="556.5"
					x2="398.03"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.03"
					y1="556.5"
					x2="398.03"
					y2="557.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.06"
					y1="556.5"
					x2="481.09"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.09"
					y1="556.5"
					x2="481.09"
					y2="557.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.09"
					y1="557.76"
					x2="476.06"
					y2="557.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.06"
					y1="557.76"
					x2="476.06"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.03"
					y1="543.92"
					x2="393"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393"
					y1="543.92"
					x2="393"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393"
					y1="542.66"
					x2="398.03"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.03"
					y1="542.66"
					x2="398.03"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.06"
					y1="542.66"
					x2="481.09"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.09"
					y1="542.66"
					x2="481.09"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.09"
					y1="543.92"
					x2="476.06"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.06"
					y1="543.92"
					x2="476.06"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="399.29 556.5 399.29 543.92 397.4 543.92 397.4 556.5 399.29 556.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="476.69 556.5 476.69 543.92 474.8 543.92 474.8 556.5 476.69 556.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="421.41 490.53 418.29 493.64 471.69 547.03 474.8 543.92 421.41 490.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="397.4"
					y1="543.92"
					x2="396.78"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.4"
					y1="556.5"
					x2="396.78"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="396.78"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.69"
					y1="543.92"
					x2="477.32"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.69"
					y1="556.5"
					x2="477.32"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="477.32"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.29"
					y1="556.5"
					x2="399.29"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.29"
					y1="543.92"
					x2="397.4"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.4"
					y1="543.92"
					x2="397.4"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.4"
					y1="556.5"
					x2="399.29"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.69"
					y1="556.5"
					x2="476.69"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.69"
					y1="543.92"
					x2="474.8"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.8"
					y1="543.92"
					x2="474.8"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.8"
					y1="556.5"
					x2="476.69"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.41"
					y1="490.53"
					x2="418.29"
					y2="493.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.29"
					y1="493.64"
					x2="471.69"
					y2="547.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.69"
					y1="547.03"
					x2="474.8"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.8"
					y1="543.92"
					x2="421.41"
					y2="490.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="396.78"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="396.78"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="393"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="543.92"
					x2="393"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="556.5"
					x2="393"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="396.78"
					y1="556.5"
					x2="393"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="477.32"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="477.32"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="481.09"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="543.92"
					x2="481.09"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="556.5"
					x2="481.09"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="477.32"
					y1="556.5"
					x2="481.09"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="598.98 557.76 604.01 557.76 604.01 556.5 598.98 556.5 598.98 557.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="598.98 543.92 604.01 543.92 604.01 542.66 598.98 542.66 598.98 543.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="598.98"
					y1="557.76"
					x2="604.01"
					y2="557.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.01"
					y1="557.76"
					x2="604.01"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.01"
					y1="556.5"
					x2="598.98"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.98"
					y1="556.5"
					x2="598.98"
					y2="557.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.95"
					y1="557.76"
					x2="520.95"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.98"
					y1="543.92"
					x2="604.01"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.01"
					y1="543.92"
					x2="604.01"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.01"
					y1="542.66"
					x2="598.98"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.98"
					y1="542.66"
					x2="598.98"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.95"
					y1="543.92"
					x2="520.95"
					y2="542.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="597.72 556.5 599.61 556.5 599.61 543.92 597.72 543.92 597.72 556.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="520.32 556.5 522.21 556.5 522.21 543.92 520.32 543.92 520.32 556.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.6 490.53 522.21 543.92 525.32 547.03 578.72 493.64 575.6 490.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="599.61"
					y1="543.92"
					x2="600.23"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.61"
					y1="556.5"
					x2="600.23"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="600.23"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.32"
					y1="543.92"
					x2="519.69"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.32"
					y1="556.5"
					x2="519.69"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.69"
					y1="543.92"
					x2="519.69"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.72"
					y1="556.5"
					x2="597.72"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.72"
					y1="543.92"
					x2="599.61"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.61"
					y1="543.92"
					x2="599.61"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.61"
					y1="556.5"
					x2="597.72"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.32"
					y1="556.5"
					x2="520.32"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.32"
					y1="543.92"
					x2="522.21"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.21"
					y1="543.92"
					x2="522.21"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.21"
					y1="556.5"
					x2="520.32"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.6"
					y1="490.53"
					x2="578.72"
					y2="493.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.72"
					y1="493.64"
					x2="525.32"
					y2="547.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.32"
					y1="547.03"
					x2="522.21"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.21"
					y1="543.92"
					x2="575.6"
					y2="490.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="600.23"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="600.23"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="604.01"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="543.92"
					x2="604.01"
					y2="543.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="556.5"
					x2="604.01"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.23"
					y1="556.5"
					x2="604.01"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.69"
					y1="543.92"
					x2="519.69"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.69"
					y1="543.92"
					x2="519.69"
					y2="556.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="357.61"
					y1="512.57"
					x2="357.61"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="345.03"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="357.61"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="357.61"
					y1="432.03"
					x2="357.61"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="345.03"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="357.61"
					y2="432.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="358.87 433.29 358.87 428.25 357.61 428.25 357.61 433.29 358.87 433.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="357.61 511.31 357.61 516.35 358.87 516.35 358.87 511.31 357.61 511.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="345.03 433.29 345.03 428.25 343.77 428.25 343.77 433.29 345.03 433.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="343.77 511.31 343.77 516.35 345.03 516.35 345.03 511.31 343.77 511.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="358.87"
					y1="433.29"
					x2="358.87"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.87"
					y1="428.25"
					x2="357.61"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="428.25"
					x2="357.61"
					y2="433.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="433.29"
					x2="358.87"
					y2="433.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="511.31"
					x2="357.61"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="516.35"
					x2="358.87"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.87"
					y1="516.35"
					x2="358.87"
					y2="511.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.87"
					y1="511.31"
					x2="357.61"
					y2="511.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="433.29"
					x2="345.03"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="428.25"
					x2="343.77"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.77"
					y1="428.25"
					x2="343.77"
					y2="433.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.77"
					y1="433.29"
					x2="345.03"
					y2="433.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.77"
					y1="511.31"
					x2="343.77"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.77"
					y1="516.35"
					x2="345.03"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="516.35"
					x2="345.03"
					y2="511.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="511.31"
					x2="343.77"
					y2="511.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="357.61 434.55 357.61 432.66 345.03 432.66 345.03 434.55 357.61 434.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="357.61 511.94 357.61 510.05 345.03 510.05 345.03 511.94 357.61 511.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="291.63 456.66 345.03 510.05 348.14 506.94 294.75 453.55 291.63 456.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="345.03"
					y1="432.66"
					x2="345.03"
					y2="432.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="432.66"
					x2="357.61"
					y2="432.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="357.61"
					y2="432.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="511.94"
					x2="345.03"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="511.94"
					x2="357.61"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="357.61"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="434.55"
					x2="345.03"
					y2="434.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="434.55"
					x2="345.03"
					y2="432.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="432.66"
					x2="357.61"
					y2="432.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="432.66"
					x2="357.61"
					y2="434.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="511.94"
					x2="345.03"
					y2="511.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="511.94"
					x2="345.03"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="510.05"
					x2="357.61"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.61"
					y1="510.05"
					x2="357.61"
					y2="511.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.63"
					y1="456.66"
					x2="294.75"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.75"
					y1="453.55"
					x2="348.14"
					y2="506.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.14"
					y1="506.94"
					x2="345.03"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="510.05"
					x2="291.63"
					y2="456.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="357.61"
					y2="432.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="357.61"
					y2="432.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="345.03"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="432.03"
					x2="345.03"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="357.61"
					y1="432.03"
					x2="357.61"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="357.61"
					y1="432.03"
					x2="357.61"
					y2="428.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="357.61"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="357.61"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="345.03"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="345.03"
					y1="512.57"
					x2="345.03"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="357.61"
					y1="512.57"
					x2="357.61"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="357.61"
					y1="512.57"
					x2="357.61"
					y2="516.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="572.85"
					x2="378.25"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="365.67"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="378.25"
					y2="572.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="653.39"
					x2="378.25"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="365.67"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="378.25"
					y2="653.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="910.38"
					x2="365.67"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="378.25"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="365.67"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="844.94"
					x2="365.67"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="378.25"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="365.67"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="928.61"
					x2="378.25"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="365.67"
					y2="792.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="837.26"
					x2="365.67"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="910.38"
					x2="365.67"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="379.51 652.14 378.25 652.14 378.25 657.17 379.51 657.17 379.51 652.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="378.25 574.11 379.51 574.11 379.51 569.07 378.25 569.07 378.25 574.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="365.67 652.14 364.41 652.14 364.41 657.17 365.67 657.17 365.67 652.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="364.41 574.11 365.67 574.11 365.67 569.07 364.41 569.07 364.41 574.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="379.51"
					y1="652.14"
					x2="379.51"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="657.17"
					x2="378.25"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="657.17"
					x2="378.25"
					y2="652.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="652.14"
					x2="379.51"
					y2="652.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="574.11"
					x2="378.25"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="569.07"
					x2="379.51"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="569.07"
					x2="379.51"
					y2="574.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="574.11"
					x2="378.25"
					y2="574.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="652.14"
					x2="365.67"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="657.17"
					x2="364.41"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="657.17"
					x2="364.41"
					y2="652.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="652.14"
					x2="365.67"
					y2="652.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="574.11"
					x2="364.41"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="569.07"
					x2="365.67"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="569.07"
					x2="365.67"
					y2="574.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="574.11"
					x2="364.41"
					y2="574.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="378.25 650.88 365.67 650.88 365.67 652.76 378.25 652.76 378.25 650.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="378.25 573.48 365.67 573.48 365.67 575.37 378.25 575.37 378.25 573.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="312.28 628.76 315.39 631.88 368.78 578.48 365.67 575.37 312.28 628.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="365.67"
					y1="652.76"
					x2="365.67"
					y2="653.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="652.76"
					x2="378.25"
					y2="653.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="378.25"
					y2="653.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="573.48"
					x2="365.67"
					y2="572.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="573.48"
					x2="378.25"
					y2="572.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="378.25"
					y2="572.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="650.88"
					x2="365.67"
					y2="650.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="650.88"
					x2="365.67"
					y2="652.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="652.76"
					x2="378.25"
					y2="652.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="652.76"
					x2="378.25"
					y2="650.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="573.48"
					x2="365.67"
					y2="573.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="573.48"
					x2="365.67"
					y2="575.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="575.37"
					x2="378.25"
					y2="575.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="575.37"
					x2="378.25"
					y2="573.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.28"
					y1="628.76"
					x2="315.39"
					y2="631.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.39"
					y1="631.88"
					x2="368.78"
					y2="578.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.78"
					y1="578.48"
					x2="365.67"
					y2="575.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="575.37"
					x2="312.28"
					y2="628.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="378.25"
					y2="653.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="378.25"
					y2="653.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="365.67"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="653.39"
					x2="365.67"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="653.39"
					x2="378.25"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="653.39"
					x2="378.25"
					y2="657.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="378.25"
					y2="572.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="378.25"
					y2="572.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="365.67"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="572.85"
					x2="365.67"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="572.85"
					x2="378.25"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="572.85"
					x2="378.25"
					y2="569.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="364.41 846.2 365.67 846.2 365.67 841.16 364.41 841.16 364.41 846.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="365.67 909.12 364.41 909.12 364.41 914.16 365.67 914.16 365.67 909.12"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="378.25 846.2 379.51 846.2 379.51 841.16 378.25 841.16 378.25 846.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="379.51 909.12 378.25 909.12 378.25 914.16 379.51 914.16 379.51 909.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="364.41"
					y1="846.2"
					x2="364.41"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="841.16"
					x2="365.67"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="841.16"
					x2="365.67"
					y2="846.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="846.2"
					x2="364.41"
					y2="846.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="909.12"
					x2="365.67"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="914.16"
					x2="364.41"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="914.16"
					x2="364.41"
					y2="909.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.41"
					y1="909.12"
					x2="365.67"
					y2="909.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="846.2"
					x2="378.25"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="841.16"
					x2="379.51"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="841.16"
					x2="379.51"
					y2="846.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="846.2"
					x2="378.25"
					y2="846.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="909.12"
					x2="379.51"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.51"
					y1="914.16"
					x2="378.25"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="914.16"
					x2="378.25"
					y2="909.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="909.12"
					x2="379.51"
					y2="909.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="365.67 847.46 378.25 847.46 378.25 845.57 365.67 845.57 365.67 847.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="365.67 909.75 378.25 909.75 378.25 907.86 365.67 907.86 365.67 909.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="420.97 865.15 417.85 862.04 375.14 904.75 378.25 907.86 420.97 865.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="378.25"
					y1="845.57"
					x2="378.25"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="845.57"
					x2="365.67"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="365.67"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="909.75"
					x2="378.25"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="909.75"
					x2="365.67"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="365.67"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="847.46"
					x2="378.25"
					y2="847.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="847.46"
					x2="378.25"
					y2="845.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="845.57"
					x2="365.67"
					y2="845.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="845.57"
					x2="365.67"
					y2="847.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="909.75"
					x2="378.25"
					y2="909.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="909.75"
					x2="378.25"
					y2="907.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="907.86"
					x2="365.67"
					y2="907.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="907.86"
					x2="365.67"
					y2="909.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.97"
					y1="865.15"
					x2="417.85"
					y2="862.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.85"
					y1="862.04"
					x2="375.14"
					y2="904.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.14"
					y1="904.75"
					x2="378.25"
					y2="907.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="907.86"
					x2="420.97"
					y2="865.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="365.67"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="365.67"
					y2="844.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="378.25"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="844.94"
					x2="378.25"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="844.94"
					x2="365.67"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="844.94"
					x2="365.67"
					y2="841.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="365.67"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="365.67"
					y2="910.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="378.25"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="378.25"
					y1="910.38"
					x2="378.25"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="910.38"
					x2="365.67"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="910.38"
					x2="365.67"
					y2="914.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="365.67"
					y1="792.48"
					x2="283.94"
					y2="792.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="283.94"
					y1="837.26"
					x2="365.67"
					y2="837.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="580.6"
					y1="70.14"
					x2="580.6"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="442"
					y1="50"
					x2="442"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="746.68"
					y1="50"
					x2="746.68"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="258.69 613.81 260.69 609.32 261.39 604.45 260.69 599.58 258.69 595.09 256.14 592.13 252.95 589.88 245.46 587.03 236.08 586.04 226.89 588.15 218.63 587.45 211.1 584.01 208.97 582.66 204.59 581.06 199.95 581.3 198.11 582.02 193.22 582.02 193.22 584.06 195.45 584.06 193.39 587.47 192.59 591.38 192.59 617.52 193.95 622.58 197.55 626.38 202.52 628 203.12 628 206.26 627.48 211.21 624.83 218.66 621.41 226.83 620.73 236.05 622.86 245.46 621.87 252.95 619.02 256.14 616.77 258.69 613.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="215.83"
					y1="595.13"
					x2="215.83"
					y2="613.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.59"
					y1="617.52"
					x2="192.59"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.53"
					y1="617.52"
					x2="193.53"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.59"
					y1="591.38"
					x2="192.59"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.53"
					y1="591.38"
					x2="193.53"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.83"
					y1="613.28"
					x2="212.35"
					y2="613.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.35"
					y1="613.28"
					x2="212.35"
					y2="610.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.35"
					y1="610.41"
					x2="215.83"
					y2="610.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.83"
					y1="595.62"
					x2="212.35"
					y2="595.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.35"
					y1="595.62"
					x2="212.35"
					y2="598.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.35"
					y1="598.5"
					x2="215.83"
					y2="598.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.87"
					y1="584.06"
					x2="193.22"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.87"
					y1="582.02"
					x2="193.22"
					y2="582.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.22"
					y1="582.02"
					x2="193.22"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.87"
					y1="582.02"
					x2="201.87"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.39"
					y1="604.45"
					x2="261.03"
					y2="607.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.03"
					y1="607.57"
					x2="260.22"
					y2="610.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.22"
					y1="610.59"
					x2="258.69"
					y2="613.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.69"
					y1="613.81"
					x2="256.14"
					y2="616.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.14"
					y1="616.77"
					x2="252.95"
					y2="619.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.95"
					y1="619.02"
					x2="249.32"
					y2="620.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.32"
					y1="620.67"
					x2="245.46"
					y2="621.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.46"
					y1="621.87"
					x2="239.23"
					y2="622.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.23"
					y1="622.95"
					x2="236.08"
					y2="623.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.08"
					y1="623.01"
					x2="232.95"
					y2="622.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.95"
					y1="622.66"
					x2="228.09"
					y2="621.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.09"
					y1="621.24"
					x2="223.39"
					y2="619.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.39"
					y1="619.04"
					x2="219.19"
					y2="616.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.19"
					y1="616.43"
					x2="215.83"
					y2="613.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.83"
					y1="620.73"
					x2="222.47"
					y2="620.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.47"
					y1="620.75"
					x2="218.22"
					y2="621.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.22"
					y1="621.48"
					x2="215.93"
					y2="622.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.93"
					y1="622.21"
					x2="213.67"
					y2="623.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.67"
					y1="623.28"
					x2="210.37"
					y2="625.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.37"
					y1="625.38"
					x2="206.96"
					y2="627.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.96"
					y1="627.24"
					x2="203.63"
					y2="627.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.63"
					y1="627.98"
					x2="200.31"
					y2="627.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.31"
					y1="627.7"
					x2="197.29"
					y2="626.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.29"
					y1="626.4"
					x2="194.86"
					y2="624.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.86"
					y1="624.12"
					x2="193.63"
					y2="621.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.63"
					y1="621.89"
					x2="192.94"
					y2="619.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.94"
					y1="619.75"
					x2="192.59"
					y2="617.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.53"
					y1="617.52"
					x2="193.62"
					y2="618.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.62"
					y1="618.52"
					x2="194.26"
					y2="620.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.26"
					y1="620.58"
					x2="195.79"
					y2="622.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.79"
					y1="622.39"
					x2="197.92"
					y2="623.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.92"
					y1="623.53"
					x2="200.73"
					y2="624.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.73"
					y1="624.07"
					x2="203.62"
					y2="624.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.62"
					y1="624.2"
					x2="205.06"
					y2="624.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.06"
					y1="624.18"
					x2="206.2"
					y2="623.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.2"
					y1="623.57"
					x2="206.53"
					y2="622.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.53"
					y1="622.87"
					x2="208.78"
					y2="614.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.78"
					y1="614.96"
					x2="209.45"
					y2="611.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.45"
					y1="611.03"
					x2="209.74"
					y2="607.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.74"
					y1="607.05"
					x2="209.74"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.89"
					y1="588.15"
					x2="222.52"
					y2="588.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.52"
					y1="588.11"
					x2="218.25"
					y2="587.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.25"
					y1="587.4"
					x2="215.95"
					y2="586.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.95"
					y1="586.67"
					x2="213.67"
					y2="585.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.67"
					y1="585.62"
					x2="210.37"
					y2="583.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.37"
					y1="583.53"
					x2="206.96"
					y2="581.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.96"
					y1="581.67"
					x2="204.74"
					y2="581.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.74"
					y1="581.05"
					x2="202.45"
					y2="580.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.45"
					y1="580.91"
					x2="200.21"
					y2="581.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.21"
					y1="581.23"
					x2="198.11"
					y2="582.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.53"
					y1="591.38"
					x2="193.62"
					y2="590.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.62"
					y1="590.38"
					x2="194.26"
					y2="588.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.26"
					y1="588.32"
					x2="195.79"
					y2="586.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.79"
					y1="586.51"
					x2="197.92"
					y2="585.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.92"
					y1="585.37"
					x2="200.73"
					y2="584.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.73"
					y1="584.83"
					x2="203.62"
					y2="584.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.62"
					y1="584.7"
					x2="205.06"
					y2="584.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.06"
					y1="584.72"
					x2="206.2"
					y2="585.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.2"
					y1="585.33"
					x2="206.53"
					y2="586.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.53"
					y1="586.03"
					x2="208.78"
					y2="593.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.78"
					y1="593.95"
					x2="209.45"
					y2="597.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.45"
					y1="597.88"
					x2="209.74"
					y2="601.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.74"
					y1="601.85"
					x2="209.74"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.39"
					y1="604.45"
					x2="261.03"
					y2="601.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.03"
					y1="601.33"
					x2="260.22"
					y2="598.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.22"
					y1="598.3"
					x2="258.69"
					y2="595.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.69"
					y1="595.09"
					x2="256.14"
					y2="592.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.14"
					y1="592.13"
					x2="252.95"
					y2="589.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.95"
					y1="589.88"
					x2="249.32"
					y2="588.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.32"
					y1="588.23"
					x2="245.46"
					y2="587.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.46"
					y1="587.03"
					x2="239.23"
					y2="585.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.23"
					y1="585.95"
					x2="236.08"
					y2="585.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.08"
					y1="585.89"
					x2="232.95"
					y2="586.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.95"
					y1="586.24"
					x2="228.09"
					y2="587.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.09"
					y1="587.66"
					x2="223.39"
					y2="589.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.39"
					y1="589.86"
					x2="219.19"
					y2="592.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.19"
					y1="592.48"
					x2="215.83"
					y2="595.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.77"
					y1="626.36"
					x2="209.48"
					y2="625.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.48"
					y1="625.86"
					x2="210.55"
					y2="624.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.55"
					y1="624.42"
					x2="210.8"
					y2="623.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.8"
					y1="623.17"
					x2="211.48"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.48"
					y1="615.14"
					x2="211.8"
					y2="607.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.8"
					y1="607.09"
					x2="211.8"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.77"
					y1="582.54"
					x2="209.48"
					y2="583.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.48"
					y1="583.04"
					x2="210.55"
					y2="584.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.55"
					y1="584.48"
					x2="210.8"
					y2="585.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.8"
					y1="585.73"
					x2="211.48"
					y2="593.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.48"
					y1="593.76"
					x2="211.8"
					y2="601.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.8"
					y1="601.81"
					x2="211.8"
					y2="604.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.45"
					y1="584.06"
					x2="194.86"
					y2="584.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.86"
					y1="584.78"
					x2="193.63"
					y2="587.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.63"
					y1="587.01"
					x2="192.94"
					y2="589.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.94"
					y1="589.15"
					x2="192.59"
					y2="591.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.37"
					y1="711.06"
					x2="240.37"
					y2="644.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.37"
					y1="644.46"
					x2="192.59"
					y2="644.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.69"
					y1="702.93"
					x2="229.69"
					y2="652.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.69"
					y1="652.59"
					x2="199.49"
					y2="652.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.49"
					y1="652.59"
					x2="199.49"
					y2="702.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.49"
					y1="702.93"
					x2="229.69"
					y2="702.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.68"
					y1="704.91"
					x2="231.68"
					y2="650.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.68"
					y1="650.61"
					x2="197.51"
					y2="650.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m209.28,677.76c0-1.64-1.33-2.97-2.97-2.97s-2.97,1.33-2.97,2.97,1.33,2.97,2.97,2.97,2.97-1.33,2.97-2.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="194.6 680.24 198.76 679.84 199.7 679.52 204.94 678.86 205.64 678.49 205.92 677.76 205.64 677.03 204.94 676.66 199.7 676.01 198.76 675.68 194.6 675.28 193.14 675.76 192.24 677 192.24 678.53 193.14 679.76 194.6 680.24"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m194.6,680.24c-1.37,0-2.48-1.11-2.48-2.47s1.11-2.48,2.48-2.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.76"
					y1="675.68"
					x2="194.6"
					y2="675.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m198.76,675.68c.34.03.66.14.94.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.94"
					y1="676.66"
					x2="199.7"
					y2="676.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m204.94,676.66c.55.07.97.54.97,1.1s-.42,1.03-.97,1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.7"
					y1="679.52"
					x2="204.94"
					y2="678.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m199.7,679.52c-.28.18-.61.29-.94.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.6"
					y1="680.24"
					x2="198.76"
					y2="679.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.07"
					y1="676.41"
					x2="198.54"
					y2="676.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.54"
					y1="679.11"
					x2="197.07"
					y2="679.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.07"
					y1="679.11"
					x2="197.07"
					y2="676.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m198.54,676.41c.74,0,1.35.61,1.35,1.35s-.6,1.35-1.35,1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m199.7,676.01c.6.38.96,1.05.96,1.76s-.36,1.37-.96,1.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="192.59 634.66 193.59 634.66 193.59 629.62 192.59 629.62 192.59 634.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="192.59"
					y1="629.62"
					x2="192.59"
					y2="634.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.59"
					y1="629.62"
					x2="192.59"
					y2="629.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.59"
					y1="634.66"
					x2="193.59"
					y2="629.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.59"
					y1="634.66"
					x2="193.59"
					y2="634.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="192.59 574.25 192.59 579.28 193.59 579.28 193.59 574.25 192.59 574.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="193.59"
					y1="574.25"
					x2="192.59"
					y2="574.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.59"
					y1="579.28"
					x2="193.59"
					y2="574.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.59"
					y1="579.28"
					x2="193.59"
					y2="579.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.59"
					y1="574.25"
					x2="192.59"
					y2="579.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="193.59 632.64 201.78 632.64 201.78 631.63 193.59 631.63 193.59 632.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="193.59"
					y1="631.63"
					x2="193.59"
					y2="632.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.78"
					y1="631.63"
					x2="193.59"
					y2="631.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.78"
					y1="632.64"
					x2="201.78"
					y2="631.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.59"
					y1="632.64"
					x2="201.78"
					y2="632.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="193.59 576.26 193.59 577.27 201.78 577.27 201.78 576.26 193.59 576.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="201.78"
					y1="576.26"
					x2="193.59"
					y2="576.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.78"
					y1="577.27"
					x2="201.78"
					y2="576.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.59"
					y1="577.27"
					x2="201.78"
					y2="577.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.59"
					y1="576.26"
					x2="193.59"
					y2="577.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="199.27 631.63 201.28 631.63 201.28 577.27 199.27 577.27 199.27 631.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="199.27"
					y1="577.27"
					x2="199.27"
					y2="631.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.28"
					y1="577.27"
					x2="199.27"
					y2="577.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.28"
					y1="631.63"
					x2="201.28"
					y2="577.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.27"
					y1="631.63"
					x2="201.28"
					y2="631.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="365.67 792.48 365.67 714.27 212.9 714.27 212.9 792.48 365.67 792.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="212.9"
					y1="792.48"
					x2="365.67"
					y2="792.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.9"
					y1="714.27"
					x2="212.9"
					y2="792.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="714.27"
					x2="212.9"
					y2="714.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.67"
					y1="792.48"
					x2="365.67"
					y2="714.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.86"
					y1="787.53"
					x2="360.72"
					y2="787.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.72"
					y1="787.53"
					x2="360.72"
					y2="719.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.72"
					y1="719.23"
					x2="217.86"
					y2="719.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.86"
					y1="719.23"
					x2="217.86"
					y2="787.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.86"
					y1="787.53"
					x2="282.03"
					y2="756.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.86"
					y1="719.23"
					x2="282.03"
					y2="750.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.72"
					y1="787.53"
					x2="296.55"
					y2="756.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.72"
					y1="719.23"
					x2="296.55"
					y2="750.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.28"
					y1="758.33"
					x2="289.28"
					y2="748.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.24"
					y1="753.38"
					x2="284.33"
					y2="753.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m297.21,753.38c0-4.38-3.55-7.93-7.93-7.93s-7.93,3.55-7.93,7.93,3.55,7.93,7.93,7.93,7.93-3.55,7.93-7.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m294.24,753.38c0-2.74-2.22-4.95-4.96-4.95s-4.95,2.22-4.95,4.95,2.22,4.96,4.95,4.96,4.96-2.22,4.96-4.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="212.9 753.38 223.41 761.11 223.41 745.64 212.9 753.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="223.41"
					y1="745.64"
					x2="212.9"
					y2="753.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.41"
					y1="761.11"
					x2="223.41"
					y2="745.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.9"
					y1="753.38"
					x2="223.41"
					y2="761.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.82"
					y1="753.38"
					x2="232.27"
					y2="753.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.41"
					y1="753.38"
					x2="223.41"
					y2="745.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.41"
					y1="745.64"
					x2="212.9"
					y2="753.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.41"
					y1="753.38"
					x2="223.41"
					y2="761.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.41"
					y1="761.11"
					x2="212.9"
					y2="753.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.62"
					y1="751.09"
					x2="231.21"
					y2="747.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.62"
					y1="755.66"
					x2="231.21"
					y2="758.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="724.07 735.59 781.5 735.59 781.5 679.15 724.07 679.15 724.07 735.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="724.07"
					y1="679.15"
					x2="724.07"
					y2="681.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="685.02"
					x2="724.07"
					y2="691.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="694.68"
					x2="724.07"
					y2="700.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="704.35"
					x2="724.07"
					y2="710.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="714.01"
					x2="724.07"
					y2="720.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="723.68"
					x2="724.07"
					y2="729.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="733.34"
					x2="724.07"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="679.15"
					x2="778.76"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.14"
					y1="679.15"
					x2="769.1"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.47"
					y1="679.15"
					x2="759.43"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.81"
					y1="679.15"
					x2="749.77"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.14"
					y1="679.15"
					x2="740.1"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.48"
					y1="679.15"
					x2="730.44"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.81"
					y1="679.15"
					x2="724.07"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="735.59"
					x2="781.5"
					y2="733.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="729.72"
					x2="781.5"
					y2="723.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="720.05"
					x2="781.5"
					y2="714.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="710.39"
					x2="781.5"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="700.72"
					x2="781.5"
					y2="694.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="691.06"
					x2="781.5"
					y2="685.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="681.39"
					x2="781.5"
					y2="679.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="735.59"
					x2="726.81"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.44"
					y1="735.59"
					x2="736.48"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.1"
					y1="735.59"
					x2="746.14"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.77"
					y1="735.59"
					x2="755.81"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.43"
					y1="735.59"
					x2="765.47"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.1"
					y1="735.59"
					x2="775.14"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.76"
					y1="735.59"
					x2="781.5"
					y2="735.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="721.1 679.36 719.36 679.36 719.36 735.38 721.1 735.38 721.1 726.59 719.67 726.59 719.67 688.15 721.1 688.15 721.1 679.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="721.1"
					y1="688.15"
					x2="721.1"
					y2="679.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="719.67"
					y1="688.15"
					x2="721.1"
					y2="688.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="719.67"
					y1="726.59"
					x2="719.67"
					y2="688.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="721.1"
					y1="726.59"
					x2="719.67"
					y2="726.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="721.1"
					y1="735.38"
					x2="721.1"
					y2="726.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="719.36"
					y1="735.38"
					x2="721.1"
					y2="735.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="719.36"
					y1="679.36"
					x2="719.36"
					y2="735.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="721.1"
					y1="679.36"
					x2="719.36"
					y2="679.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<polyline
					points="721.1 677.16 721.1 737.57 724.07 737.57 724.07 677.16 721.1 677.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="724.07"
					y1="677.16"
					x2="721.1"
					y2="677.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="724.07"
					y1="737.57"
					x2="724.07"
					y2="677.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="721.1"
					y1="737.57"
					x2="724.07"
					y2="737.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="721.1"
					y1="677.16"
					x2="721.1"
					y2="737.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="721.1"
					y1="735.38"
					x2="719.36"
					y2="735.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.36"
					y1="735.38"
					x2="719.36"
					y2="679.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.36"
					y1="679.36"
					x2="721.1"
					y2="679.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="737.57"
					x2="721.1"
					y2="677.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="688.15"
					x2="719.67"
					y2="688.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.67"
					y1="688.15"
					x2="719.67"
					y2="726.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.67"
					y1="726.59"
					x2="721.1"
					y2="726.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="737.57"
					x2="721.1"
					y2="737.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="677.16"
					x2="724.07"
					y2="677.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.07"
					y1="677.16"
					x2="724.07"
					y2="737.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.41"
					y1="845.97"
					x2="713.41"
					y2="845.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.41"
					y1="845.97"
					x2="713.41"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.7"
					y1="845.97"
					x2="719.7"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="716.06 745 716.06 820.51 781.5 820.51 781.5 745 716.06 745"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="716.06"
					y1="745"
					x2="716.06"
					y2="820.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="745"
					x2="781.5"
					y2="820.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.52"
					y1="745"
					x2="779.52"
					y2="820.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.06"
					y1="745"
					x2="781.5"
					y2="745"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.06"
					y1="820.51"
					x2="781.5"
					y2="820.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.04"
					y1="749.95"
					x2="719.04"
					y2="815.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.04"
					y1="815.55"
					x2="721.02"
					y2="817.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.02"
					y1="817.54"
					x2="776.55"
					y2="817.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.55"
					y1="817.54"
					x2="778.53"
					y2="815.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.53"
					y1="815.55"
					x2="778.53"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.53"
					y1="749.95"
					x2="776.55"
					y2="747.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.55"
					y1="747.97"
					x2="721.02"
					y2="747.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.02"
					y1="747.97"
					x2="719.04"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m742.33,763.88c0-5.47-4.44-9.91-9.91-9.91s-9.91,4.44-9.91,9.91,4.44,9.91,9.91,9.91,9.91-4.44,9.91-9.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m772.57,763.88c0-4.1-3.33-7.43-7.43-7.43s-7.43,3.33-7.43,7.43,3.33,7.43,7.43,7.43,7.43-3.33,7.43-7.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m739.85,801.63c0-4.11-3.33-7.44-7.43-7.44s-7.43,3.33-7.43,7.44,3.33,7.43,7.43,7.43,7.43-3.33,7.43-7.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m775.05,801.63c0-5.48-4.44-9.91-9.91-9.91s-9.91,4.43-9.91,9.91,4.44,9.91,9.91,9.91,9.91-4.43,9.91-9.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="726.13 618.56 726.13 668.09 726.71 669.49 728.11 670.07 779.52 670.07 780.92 669.49 781.5 668.09 781.5 618.56 780.92 617.16 779.52 616.58 728.11 616.58 726.71 617.16 726.13 618.56"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m726.13,618.56c0-1.09.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.52"
					y1="616.58"
					x2="728.11"
					y2="616.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m779.52,616.58c1.09,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.5"
					y1="668.09"
					x2="781.5"
					y2="618.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m781.5,668.09c0,1.09-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.11"
					y1="670.07"
					x2="779.52"
					y2="670.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m728.11,670.07c-1.09,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.13"
					y1="618.56"
					x2="726.13"
					y2="668.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.08"
					y1="623.52"
					x2="731.08"
					y2="663.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.07"
					y1="665.11"
					x2="769.61"
					y2="665.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.59"
					y1="663.13"
					x2="771.59"
					y2="623.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.61"
					y1="621.53"
					x2="733.07"
					y2="621.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.08"
					y1="623.52"
					x2="731.08"
					y2="623.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m733.07,665.11c-1.1,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m771.59,663.13c0,1.1-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m769.61,621.53c1.09,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m731.08,623.52c0-1.1.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m764.66,643.32c0-1.64-1.33-2.97-2.97-2.97s-2.97,1.33-2.97,2.97,1.33,2.98,2.97,2.98,2.97-1.33,2.97-2.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="758.92 642.43 758.29 642.69 758.03 643.33 758.29 643.96 758.93 644.21 778.53 644.21 779.16 643.95 779.42 643.32 779.16 642.69 778.53 642.43 758.92 642.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="778.53"
					y1="642.43"
					x2="758.92"
					y2="642.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m778.53,642.43c.49,0,.89.4.89.89s-.4.89-.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.93"
					y1="644.21"
					x2="778.53"
					y2="644.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m758.93,644.21h0c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.48 641.34 773.48 642.43 778.53 642.43 779.16 642.69 779.42 643.32 779.16 643.95 778.53 644.21 773.48 644.21 773.48 645.3 779.92 645.3 779.92 641.34 773.48 641.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="779.92"
					y1="641.34"
					x2="773.48"
					y2="641.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.92"
					y1="645.3"
					x2="779.92"
					y2="641.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.48"
					y1="645.3"
					x2="779.92"
					y2="645.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.48"
					y1="644.21"
					x2="773.48"
					y2="645.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.53"
					y1="644.21"
					x2="773.48"
					y2="644.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m778.53,642.43c.49,0,.89.4.89.89s-.4.89-.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.48"
					y1="642.43"
					x2="778.53"
					y2="642.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.48"
					y1="641.34"
					x2="773.48"
					y2="642.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="769.91 641.37 769.91 642.43 773.38 642.43 773.38 641.37 769.91 641.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.38"
					y1="641.37"
					x2="769.91"
					y2="641.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.38"
					y1="642.43"
					x2="773.38"
					y2="641.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.91"
					y1="642.43"
					x2="773.38"
					y2="642.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.91"
					y1="641.37"
					x2="769.91"
					y2="642.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="769.91 645.27 773.38 645.27 773.38 644.21 769.91 644.21 769.91 645.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="769.91"
					y1="644.21"
					x2="769.91"
					y2="645.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.38"
					y1="644.21"
					x2="769.91"
					y2="644.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.38"
					y1="645.27"
					x2="773.38"
					y2="644.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.91"
					y1="645.27"
					x2="773.38"
					y2="645.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.92"
					y1="902.53"
					x2="353.54"
					y2="902.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.54"
					y1="902.53"
					x2="353.54"
					y2="854.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.92"
					y1="912.6"
					x2="335.92"
					y2="844.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.62"
					y1="844.64"
					x2="290.62"
					y2="912.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.62"
					y1="912.6"
					x2="358.58"
					y2="912.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.58"
					y1="844.64"
					x2="290.62"
					y2="844.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.32"
					y1="912.6"
					x2="357.32"
					y2="844.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.92"
					y1="854.71"
					x2="353.54"
					y2="854.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.58"
					y1="912.6"
					x2="358.58"
					y2="844.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="556.5"
					x2="751.3"
					y2="559.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="562.9"
					x2="751.3"
					y2="568.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="572.57"
					x2="751.3"
					y2="578.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="582.23"
					x2="751.3"
					y2="588.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="591.9"
					x2="751.3"
					y2="597.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="601.56"
					x2="751.3"
					y2="607.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="611.23"
					x2="751.3"
					y2="617.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="620.89"
					x2="751.3"
					y2="626.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="630.56"
					x2="751.3"
					y2="636.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="640.23"
					x2="751.3"
					y2="646.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="649.89"
					x2="751.3"
					y2="655.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="659.56"
					x2="751.3"
					y2="665.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="669.22"
					x2="751.3"
					y2="675.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="678.89"
					x2="751.3"
					y2="684.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="688.55"
					x2="751.3"
					y2="694.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="698.22"
					x2="751.3"
					y2="704.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="707.88"
					x2="751.3"
					y2="713.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="717.55"
					x2="751.3"
					y2="723.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="727.21"
					x2="751.3"
					y2="733.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="736.88"
					x2="751.3"
					y2="742.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="746.54"
					x2="751.3"
					y2="752.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="756.21"
					x2="751.3"
					y2="762.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="765.87"
					x2="751.3"
					y2="771.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="775.54"
					x2="751.3"
					y2="781.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="785.2"
					x2="751.3"
					y2="791.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="794.87"
					x2="751.3"
					y2="800.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="804.53"
					x2="751.3"
					y2="810.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="814.2"
					x2="751.3"
					y2="820.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="823.86"
					x2="751.3"
					y2="829.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="833.53"
					x2="751.3"
					y2="839.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.3"
					y1="843.2"
					x2="751.3"
					y2="845.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="556.5"
					x2="721.1"
					y2="745"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.41"
					y1="918.96"
					x2="708.44"
					y2="918.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.44"
					y1="918.96"
					x2="708.44"
					y2="916.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.44"
					y1="916.44"
					x2="713.41"
					y2="916.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="845.97"
					x2="721.1"
					y2="851.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="855.27"
					x2="721.1"
					y2="861.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="864.94"
					x2="721.1"
					y2="870.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="874.6"
					x2="721.1"
					y2="880.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="884.27"
					x2="721.1"
					y2="890.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="893.93"
					x2="721.1"
					y2="899.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="903.6"
					x2="721.1"
					y2="909.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="913.26"
					x2="721.1"
					y2="919.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="922.93"
					x2="721.1"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.1"
					y1="820.51"
					x2="721.1"
					y2="845.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.41"
					y1="50"
					x2="442"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442"
					y1="70.14"
					x2="245.41"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.6"
					y1="50"
					x2="746.68"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.68"
					y1="70.14"
					x2="580.6"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.17"
					y1="902.53"
					x2="298.17"
					y2="854.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.17"
					y1="854.71"
					x2="330.89"
					y2="854.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.89"
					y1="854.71"
					x2="330.89"
					y2="902.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.89"
					y1="902.53"
					x2="298.17"
					y2="902.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="827.54 50 827.54 564.06 801.64 564.06 801.64 825.83 827.54 825.83 827.54 948.74 484.97 948.74 484.97 928.6 807.42 928.6 807.42 845.97 781.51 845.97 781.51 556.5 600.23 556.5 600.23 543.92 807.42 543.92 807.42 70.14 746.68 70.14 746.68 50 827.54 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="580.59 50 580.59 70.14 536.82 70.14 536.82 149.84 506.47 149.84 506.47 543.92 519.69 543.92 519.69 556.5 477.31 556.5 477.31 543.92 493.88 543.92 493.88 149.84 463.95 149.84 463.95 70.14 442 70.14 442 50 580.59 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="365.67 572.85 365.67 556.5 192.58 556.5 192.58 711.05 212.91 711.05 212.91 792.48 365.67 792.48 365.67 653.4 378.25 653.4 378.25 844.95 365.67 844.95 365.67 837.27 283.94 837.27 283.94 928.6 365.67 928.6 365.67 910.38 378.25 910.38 378.25 928.6 389.33 928.6 389.33 948.74 263.8 948.74 263.8 812.62 192.77 812.62 192.26 731.19 172.45 731.19 172.45 536.36 176.57 536.36 176.57 50 245.41 50 245.41 70.14 196.7 70.14 196.7 367.1 357.61 367.1 357.61 432.03 345.03 432.03 345.03 379.68 196.7 379.68 196.7 543.92 345.03 543.92 345.03 512.57 357.61 512.57 357.61 543.92 396.77 543.92 396.77 556.5 378.25 556.5 378.25 572.85 365.67 572.85"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
			</g>
			<g id="text">
				<path d="m741.01,712.63v-11.68h4.02c.91,0,1.6.06,2.08.17.67.15,1.24.43,1.71.84.62.52,1.08,1.19,1.38,2,.31.81.46,1.73.46,2.77,0,.89-.1,1.67-.31,2.36-.21.68-.47,1.25-.8,1.7-.32.45-.68.8-1.07,1.06-.38.25-.85.45-1.39.58-.54.13-1.17.2-1.87.2h-4.21Zm1.55-1.38h2.49c.77,0,1.37-.07,1.81-.21.44-.14.79-.35,1.05-.61.37-.37.65-.86.85-1.47.21-.62.31-1.37.31-2.25,0-1.22-.2-2.16-.61-2.81-.4-.66-.88-1.1-1.46-1.32-.41-.16-1.08-.24-2-.24h-2.45v8.92Zm12.27,1.38l-3.1-11.68h1.58l1.78,7.65c.19.8.36,1.6.49,2.39.3-1.25.47-1.97.53-2.16l2.22-7.88h1.86l1.67,5.91c.42,1.47.72,2.84.91,4.13.15-.74.34-1.58.58-2.54l1.83-7.5h1.55l-3.2,11.68h-1.49l-2.46-8.9c-.21-.74-.33-1.2-.37-1.37-.12.54-.24.99-.34,1.37l-2.48,8.9h-1.58Z" />
				<path d="m756.72,894.28h-1.64l-1.97-3.29c-.18-.31-.36-.57-.52-.78-.17-.22-.34-.4-.52-.53-.17-.14-.37-.23-.57-.29-.2-.07-.43-.1-.69-.1h-1.13v5h-1.38v-11.75h3.51c.51,0,.99.07,1.42.2.44.13.81.32,1.13.58.32.26.57.59.75.98.18.39.27.84.27,1.37,0,.41-.06.79-.19,1.13-.12.34-.29.64-.52.91-.22.27-.5.5-.82.69-.32.19-.67.33-1.07.43v.03c.2.09.37.19.51.3.15.11.29.24.42.39.13.15.26.33.39.52.13.19.28.42.43.67l2.2,3.53Zm-7.05-10.5v4.26h1.87c.34,0,.66-.05.95-.16.29-.1.55-.25.76-.44.21-.2.38-.43.5-.71.12-.28.18-.6.18-.95,0-.63-.2-1.12-.61-1.47-.4-.36-.99-.53-1.76-.53h-1.88Zm15.07,6.64h-5.92c.02.93.27,1.65.75,2.16.48.51,1.14.76,1.98.76.94,0,1.81-.31,2.61-.93v1.26c-.74.54-1.71.8-2.92.8s-2.12-.38-2.79-1.14c-.68-.76-1.02-1.84-1.02-3.22,0-1.31.37-2.37,1.11-3.19.74-.82,1.66-1.24,2.76-1.24s1.95.36,2.55,1.07c.6.71.9,1.7.9,2.96v.7Zm-1.38-1.14c0-.78-.19-1.38-.57-1.81-.37-.43-.88-.65-1.53-.65s-1.17.23-1.61.68c-.44.45-.72,1.05-.82,1.78h4.53Zm7.41-6.24c-.26-.15-.56-.22-.89-.22-.94,0-1.41.59-1.41,1.78v1.29h1.97v1.15h-1.97v7.24h-1.34v-7.24h-1.43v-1.15h1.43v-1.36c0-.88.25-1.57.76-2.08.51-.51,1.14-.77,1.9-.77.41,0,.73.05.98.15v1.21Z" />
				<path d="m772.2,894.46c-.25,0-.47-.09-.65-.27-.17-.18-.26-.4-.26-.65s.09-.47.26-.65c.18-.19.4-.28.65-.28s.48.09.66.28c.18.18.27.4.27.65s-.09.47-.27.65c-.18.18-.4.27-.66.27Z" />
				<path d="m259.54,646.12v-18.25h5.19c1.58,0,2.83.39,3.75,1.16.92.77,1.39,1.78,1.39,3.02,0,1.03-.28,1.93-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.21.61,2.95,1.4.74.78,1.11,1.8,1.11,3.05,0,1.56-.56,2.82-1.68,3.79-1.12.97-2.53,1.45-4.24,1.45h-5.32Zm2.14-16.31v5.89h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1.01-1.37,1.01-2.39,0-1.77-1.17-2.66-3.5-2.66h-2.46Zm0,7.81v6.57h2.9c1.26,0,2.23-.3,2.91-.89.7-.59,1.04-1.41,1.04-2.44,0-2.15-1.47-3.23-4.4-3.23h-2.46Zm21.84,8.5h-2.09v-2.04h-.05c-.91,1.56-2.24,2.34-4.01,2.34-1.3,0-2.32-.34-3.05-1.03-.73-.69-1.09-1.6-1.09-2.74,0-2.43,1.43-3.85,4.3-4.25l3.91-.55c0-2.21-.89-3.32-2.68-3.32-1.57,0-2.99.53-4.25,1.6v-2.14c1.28-.81,2.76-1.22,4.43-1.22,3.06,0,4.59,1.62,4.59,4.86v8.47Zm-2.09-6.59l-3.14.43c-.97.14-1.7.38-2.19.73-.49.34-.74.95-.74,1.82,0,.64.22,1.16.67,1.57.46.4,1.06.6,1.82.6,1.03,0,1.89-.36,2.56-1.08.68-.73,1.02-1.65,1.02-2.76v-1.3Zm12.07,6.46c-.49.27-1.14.41-1.95.41-2.28,0-3.42-1.27-3.42-3.82v-7.71h-2.24v-1.78h2.24v-3.18l2.09-.67v3.86h3.28v1.78h-3.28v7.34c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm13.6.13h-2.09v-7.51c0-2.71-1.01-4.07-3.03-4.07-1.02,0-1.87.39-2.57,1.18-.7.78-1.04,1.79-1.04,3.02v7.38h-2.09v-19.29h2.09v8.42h.05c1-1.65,2.43-2.47,4.28-2.47,2.93,0,4.4,1.77,4.4,5.31v8.03Z" />
				<path d="m605.51,302.85v-18.25h5.19c1.58,0,2.83.39,3.75,1.16.92.77,1.39,1.78,1.39,3.02,0,1.03-.28,1.93-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.21.61,2.95,1.4.74.78,1.11,1.8,1.11,3.05,0,1.56-.56,2.82-1.68,3.79s-2.53,1.45-4.24,1.45h-5.32Zm2.14-16.31v5.89h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1.01-1.37,1.01-2.39,0-1.77-1.17-2.66-3.5-2.66h-2.46Zm0,7.81v6.57h2.9c1.26,0,2.23-.3,2.91-.89.7-.59,1.04-1.41,1.04-2.44,0-2.15-1.47-3.23-4.4-3.23h-2.46Zm22.96,2.51h-9.2c.03,1.45.42,2.57,1.17,3.36.75.79,1.77,1.18,3.08,1.18,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.54,1.25s-3.29-.59-4.34-1.77c-1.05-1.19-1.58-2.85-1.58-5,0-2.03.57-3.68,1.72-4.95,1.15-1.28,2.58-1.92,4.29-1.92s3.02.55,3.96,1.65c.93,1.1,1.4,2.63,1.4,4.59v1.09Zm-2.14-1.77c0-1.2-.3-2.14-.88-2.81-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.7-1.11,1.62-1.27,2.76h7.04Zm16.39,7.76h-2.09v-2.21h-.05c-.97,1.68-2.46,2.52-4.48,2.52-1.64,0-2.95-.58-3.93-1.74-.98-1.17-1.46-2.76-1.46-4.77,0-2.15.54-3.88,1.63-5.18,1.09-1.3,2.53-1.95,4.34-1.95s3.09.7,3.91,2.11h.05v-8.07h2.09v19.29Zm-2.09-5.89v-1.92c0-1.05-.35-1.94-1.04-2.67-.7-.73-1.58-1.09-2.65-1.09-1.27,0-2.27.47-3,1.4-.73.93-1.09,2.22-1.09,3.87,0,1.5.35,2.69,1.04,3.56.7.87,1.65,1.3,2.82,1.3s2.1-.42,2.82-1.26c.73-.84,1.09-1.9,1.09-3.18Zm13.09-5.03c-.36-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.98-.89,3.44v6.64h-2.09v-13.03h2.09v2.68h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.29-.78,2.05-.78.54,0,.96.06,1.25.18v2.16Zm7.7,11.22c-1.93,0-3.46-.61-4.62-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13,1.2-1.23,2.81-1.84,4.85-1.84s3.46.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.77s.39,2.76,1.18,3.65c.79.89,1.84,1.34,3.17,1.34s2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.77c-.72-.88-1.76-1.32-3.1-1.32Zm15.1,11.88c-1.93,0-3.46-.61-4.62-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13,1.2-1.23,2.81-1.84,4.85-1.84s3.46.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.77s.39,2.76,1.18,3.65c.79.89,1.84,1.34,3.17,1.34s2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.77c-.72-.88-1.76-1.32-3.1-1.32Zm28.15,11.58h-2.09v-7.48c0-1.44-.22-2.49-.67-3.13-.44-.64-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.81-.93,1.79-.93,2.93v7.43h-2.09v-7.74c0-2.56-.99-3.84-2.96-3.84-.92,0-1.67.39-2.26,1.16-.59.76-.89,1.76-.89,2.99v7.43h-2.09v-13.03h2.09v2.06h.05c.92-1.58,2.27-2.37,4.05-2.37.89,0,1.67.25,2.33.75.66.49,1.12,1.14,1.36,1.95.97-1.8,2.41-2.7,4.33-2.7,2.87,0,4.3,1.77,4.3,5.31v8.03Z" />
				<path d="m610.72,329.9h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Zm12.97-6.69c0,1.11-.1,2.09-.31,2.95-.2.86-.49,1.58-.87,2.17-.38.59-.84,1.03-1.4,1.34-.55.3-1.17.45-1.88.45-.67,0-1.26-.14-1.79-.43-.52-.3-.96-.72-1.31-1.29-.36-.56-.63-1.25-.81-2.06-.19-.82-.28-1.76-.28-2.81,0-1.16.1-2.18.29-3.07.2-.89.48-1.63.86-2.23.38-.6.84-1.06,1.4-1.36.56-.31,1.2-.46,1.92-.46,2.78,0,4.17,2.27,4.17,6.8Zm-1.55.15c0-3.77-.9-5.66-2.69-5.66-1.89,0-2.84,1.92-2.84,5.76,0,3.58.93,5.38,2.78,5.38s2.75-1.83,2.75-5.48Z" />
				<rect x="626" y="316.63" width="1.34" height="4.14" />
				<path d="m638.22,323.21c0,1.11-.1,2.09-.31,2.95-.2.86-.49,1.58-.87,2.17-.38.59-.84,1.03-1.4,1.34-.55.3-1.17.45-1.88.45-.67,0-1.26-.14-1.79-.43-.52-.3-.96-.72-1.31-1.29-.36-.56-.63-1.25-.81-2.06-.19-.82-.28-1.76-.28-2.81,0-1.16.1-2.18.29-3.07.2-.89.48-1.63.86-2.23.38-.6.84-1.06,1.4-1.36.56-.31,1.2-.46,1.92-.46,2.78,0,4.17,2.27,4.17,6.8Zm-1.55.15c0-3.77-.9-5.66-2.69-5.66-1.89,0-2.84,1.92-2.84,5.76,0,3.58.93,5.38,2.78,5.38s2.75-1.83,2.75-5.48Z" />
				<path d="m641.87,316.63v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m660.11,320.42l-3.18,4.79,3.13,4.68h-1.77l-1.86-3.07c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.43.72l-1.9,3.07h-1.75l3.23-4.64-3.09-4.83h1.77l1.83,3.24c.14.24.27.49.4.74h.04l2.37-3.98h1.67Z" />
				<path d="m672.25,329.9h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Zm12.5-4.05c0,.65-.11,1.23-.33,1.76s-.54.97-.95,1.35c-.41.38-.9.67-1.48.87s-1.22.31-1.93.31c-1.23,0-2.15-.19-2.75-.56v-1.61c.9.58,1.82.87,2.77.87.48,0,.91-.07,1.3-.21.39-.14.72-.34.99-.59.27-.25.48-.56.62-.92.15-.36.22-.75.22-1.17,0-.86-.29-1.54-.87-2.03-.58-.49-1.42-.74-2.53-.74-.18,0-.37,0-.56,0-.2,0-.39.02-.59.03-.2,0-.39.02-.58.03-.19.01-.35.03-.51.05l.45-6.65h6.13v1.37h-4.82l-.27,3.89c.2-.01.41-.02.63-.03.22-.01.42-.02.59-.02.7,0,1.33.09,1.89.28.56.19,1.02.45,1.41.8.39.34.68.76.88,1.26.2.49.31,1.05.31,1.67Z" />
				<rect x="687.53" y="316.63" width="1.34" height="4.14" />
				<path d="m699.6,322.47c0,1.22-.12,2.3-.36,3.25-.24.94-.59,1.75-1.05,2.41-.46.65-1.03,1.15-1.69,1.5-.67.34-1.42.51-2.28.51s-1.65-.15-2.31-.46v-1.45c.73.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.47-.25.88-.6,1.2-1.07.33-.47.58-1.06.75-1.75.17-.69.26-1.48.26-2.38h-.04c-.57,1.14-1.55,1.71-2.96,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.8-1.31-.19-.51-.29-1.06-.29-1.67,0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.4.38-.39.83-.7,1.35-.92.52-.22,1.09-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.3,1.18.35.51.62,1.14.8,1.9.19.75.28,1.61.28,2.58Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.07-.23-.3-.52-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.02.22c-.31.14-.59.35-.82.61-.23.26-.41.57-.55.93-.13.36-.19.75-.19,1.17,0,.47.06.89.19,1.26.13.37.31.68.55.94.23.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.59-.31.81-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<path d="m703.4,316.63v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m275.06,497.52l-3.75,13.27h-1.82l-2.73-9.7c-.12-.41-.19-.86-.21-1.35h-.04c-.04.46-.12.9-.24,1.33l-2.75,9.71h-1.8l-3.89-13.27h1.71l2.82,10.18c.12.43.19.87.22,1.33h.05c.03-.33.13-.77.29-1.33l2.93-10.18h1.49l2.81,10.25c.1.35.17.76.22,1.24h.04c.02-.32.11-.75.25-1.28l2.71-10.21h1.68Zm8.35,13.27h-1.52v-1.48h-.04c-.66,1.13-1.63,1.7-2.91,1.7-.94,0-1.68-.25-2.22-.75-.53-.5-.8-1.16-.8-1.99,0-1.77,1.04-2.8,3.13-3.09l2.84-.4c0-1.61-.65-2.41-1.95-2.41-1.14,0-2.17.39-3.09,1.17v-1.55c.93-.59,2-.89,3.22-.89,2.23,0,3.34,1.18,3.34,3.53v6.16Zm-1.52-4.79l-2.29.31c-.7.1-1.23.27-1.59.53-.36.25-.54.69-.54,1.32,0,.46.16.84.49,1.14.33.29.77.43,1.32.43.75,0,1.37-.26,1.86-.79.49-.53.74-1.2.74-2.01v-.94Zm5.7,4.79h-1.52v-14.03h1.52v14.03Zm10.73,0h-2.13l-4.18-4.55h-.04v4.55h-1.52v-14.03h1.52v8.89h.04l3.98-4.34h1.99l-4.39,4.57,4.74,4.9Z" />
				<rect x="299.48" y="504.91" width="5.05" height="1.19" />
				<path d="m309.02,510.79h-1.55v-13.27h1.55v13.27Zm11.16,0h-1.52v-5.4c0-2.01-.73-3.02-2.2-3.02-.76,0-1.39.29-1.89.86-.49.57-.74,1.29-.74,2.16v5.4h-1.52v-9.47h1.52v1.57h.04c.72-1.2,1.75-1.79,3.11-1.79,1.04,0,1.83.34,2.38,1.01.55.67.82,1.63.82,2.9v5.79Z" />
				<path d="m274.43,535.5c-.98.52-2.2.78-3.66.78-1.89,0-3.4-.61-4.53-1.82s-1.7-2.81-1.7-4.78c0-2.12.64-3.84,1.92-5.14,1.28-1.31,2.9-1.96,4.86-1.96,1.26,0,2.3.18,3.13.55v1.66c-.95-.53-2-.8-3.15-.8-1.52,0-2.76.51-3.71,1.53-.94,1.02-1.42,2.38-1.42,4.08s.44,2.9,1.32,3.87c.89.96,2.05,1.43,3.49,1.43,1.33,0,2.49-.3,3.46-.89v1.51Zm4.02.56h-1.52v-14.03h1.52v14.03Zm7.03.22c-1.4,0-2.52-.44-3.36-1.32-.83-.89-1.25-2.06-1.25-3.52,0-1.59.43-2.83,1.3-3.73.87-.89,2.04-1.34,3.52-1.34s2.51.43,3.3,1.3c.8.87,1.19,2.08,1.19,3.62s-.43,2.72-1.29,3.64c-.85.91-2,1.36-3.43,1.36Zm.11-8.64c-.97,0-1.75.33-2.31,1-.57.66-.85,1.57-.85,2.74s.29,2.01.86,2.66c.57.65,1.34.97,2.3.97s1.73-.32,2.26-.95c.53-.64.8-1.54.8-2.71s-.27-2.1-.8-2.74c-.52-.64-1.28-.96-2.26-.96Zm6.46,8.08v-1.63c.83.61,1.74.92,2.73.92,1.33,0,2-.44,2-1.33,0-.25-.06-.47-.18-.64-.11-.18-.27-.34-.46-.47-.19-.14-.42-.26-.68-.36-.26-.11-.54-.23-.84-.34-.42-.17-.79-.33-1.11-.5-.31-.17-.58-.36-.8-.57-.21-.22-.37-.46-.48-.73-.1-.27-.16-.59-.16-.95,0-.44.1-.84.31-1.17.2-.35.47-.63.81-.86.34-.23.72-.41,1.16-.53.44-.12.89-.18,1.35-.18.82,0,1.55.14,2.2.43v1.54c-.7-.46-1.5-.68-2.41-.68-.28,0-.54.03-.77.1-.23.06-.43.15-.59.27-.16.12-.29.26-.38.43-.09.16-.13.34-.13.54,0,.25.04.45.13.62.09.17.23.31.4.44.17.13.38.25.63.35s.53.22.84.34c.42.16.8.33,1.13.5.33.17.62.36.85.57.23.21.41.45.54.73.13.28.19.61.19.99,0,.47-.1.88-.31,1.22-.2.35-.48.63-.82.86-.35.23-.74.4-1.19.51-.45.11-.92.17-1.42.17-.97,0-1.82-.19-2.53-.56Zm16.22-4.02h-6.69c.02,1.05.31,1.87.85,2.44.54.57,1.29.86,2.24.86,1.07,0,2.05-.35,2.94-1.05v1.42c-.83.6-1.93.91-3.3.91s-2.39-.43-3.15-1.29c-.76-.86-1.15-2.08-1.15-3.64,0-1.47.42-2.67,1.25-3.6.84-.93,1.88-1.4,3.12-1.4s2.2.4,2.88,1.2c.68.8,1.02,1.92,1.02,3.34v.8Zm-1.55-1.29c0-.88-.22-1.56-.64-2.04-.41-.49-.99-.73-1.73-.73s-1.32.26-1.82.77c-.5.51-.81,1.18-.93,2.01h5.12Zm8.25,5.55c-.36.2-.83.3-1.42.3-1.66,0-2.49-.93-2.49-2.78v-5.61h-1.63v-1.3h1.63v-2.31l1.52-.49v2.8h2.39v1.3h-2.39v5.34c0,.64.11,1.09.32,1.36.22.27.57.41,1.07.41.38,0,.71-.1.99-.31v1.3Z" />
				<path d="m427.9,839.29h-9.67v-18.25h9.26v1.93h-7.13v6.07h6.59v1.92h-6.59v6.39h7.53v1.93Zm14.07,0h-2.09v-7.43c0-2.77-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.6,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.03h2.09v2.16h.05c.98-1.65,2.41-2.47,4.28-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Zm10-.13c-.49.27-1.14.41-1.95.41-2.28,0-3.42-1.27-3.42-3.82v-7.71h-2.24v-1.78h2.24v-3.18l2.09-.67v3.86h3.28v1.78h-3.28v7.34c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm9.6-10.79c-.36-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.98-.89,3.44v6.64h-2.09v-13.03h2.09v2.68h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.29-.78,2.05-.78.54,0,.96.06,1.25.18v2.16Zm12.66-2.11l-5.99,15.12c-1.07,2.7-2.57,4.05-4.5,4.05-.54,0-1-.06-1.36-.17v-1.87c.45.15.86.23,1.23.23,1.05,0,1.84-.63,2.37-1.88l1.04-2.47-5.09-13h2.32l3.52,10.03c.04.13.13.46.27.99h.08c.04-.2.13-.53.25-.97l3.7-10.05h2.16Z" />
				<path d="m291.59,216.41v-18.25h5.19c1.58,0,2.83.39,3.75,1.16s1.39,1.78,1.39,3.02c0,1.03-.28,1.93-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.21.61,2.95,1.4.74.78,1.11,1.8,1.11,3.05,0,1.56-.56,2.82-1.68,3.79s-2.53,1.45-4.24,1.45h-5.32Zm2.14-16.31v5.89h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1.01-1.37,1.01-2.39,0-1.77-1.17-2.66-3.5-2.66h-2.46Zm0,7.81v6.57h2.9c1.26,0,2.23-.3,2.91-.89.7-.59,1.04-1.41,1.04-2.44,0-2.15-1.47-3.23-4.4-3.23h-2.46Zm22.96,2.51h-9.2c.03,1.45.42,2.57,1.17,3.36.75.79,1.77,1.18,3.08,1.18,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.54,1.25s-3.29-.59-4.34-1.77c-1.05-1.19-1.58-2.85-1.58-5,0-2.03.57-3.68,1.72-4.95,1.15-1.28,2.58-1.92,4.29-1.92s3.02.55,3.96,1.65,1.4,2.63,1.4,4.59v1.09Zm-2.14-1.77c0-1.2-.3-2.14-.88-2.81-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.7-1.11,1.62-1.27,2.76h7.04Zm16.39,7.76h-2.09v-2.21h-.05c-.97,1.68-2.46,2.52-4.48,2.52-1.64,0-2.95-.58-3.93-1.74-.98-1.17-1.46-2.76-1.46-4.77,0-2.15.54-3.88,1.63-5.18,1.09-1.3,2.53-1.95,4.34-1.95s3.09.7,3.91,2.11h.05v-8.07h2.09v19.29Zm-2.09-5.89v-1.92c0-1.05-.35-1.94-1.04-2.67-.7-.73-1.58-1.09-2.65-1.09-1.27,0-2.27.47-3,1.4-.73.93-1.09,2.22-1.09,3.87,0,1.5.35,2.69,1.04,3.56.7.87,1.65,1.3,2.82,1.3s2.1-.42,2.82-1.26c.73-.84,1.09-1.9,1.09-3.18Zm13.09-5.03c-.36-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.98-.89,3.44v6.64h-2.09v-13.03h2.09v2.68h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.29-.78,2.05-.78.54,0,.96.06,1.25.18v2.16Zm7.7,11.22c-1.93,0-3.47-.61-4.62-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13,1.2-1.23,2.81-1.84,4.85-1.84s3.46.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.77s.39,2.76,1.18,3.65,1.84,1.34,3.17,1.34,2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.77c-.72-.88-1.76-1.32-3.1-1.32Zm15.1,11.88c-1.93,0-3.47-.61-4.62-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13,1.2-1.23,2.81-1.84,4.85-1.84s3.46.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.77s.39,2.76,1.18,3.65c.79.89,1.84,1.34,3.17,1.34s2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.77c-.72-.88-1.76-1.32-3.1-1.32Zm28.15,11.58h-2.09v-7.48c0-1.44-.22-2.49-.67-3.13-.44-.64-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.81-.93,1.79-.93,2.93v7.43h-2.09v-7.74c0-2.56-.99-3.84-2.96-3.84-.92,0-1.67.39-2.26,1.16-.59.76-.89,1.76-.89,2.99v7.43h-2.09v-13.03h2.09v2.06h.05c.92-1.58,2.27-2.37,4.05-2.37.89,0,1.67.25,2.33.75.66.49,1.12,1.14,1.36,1.95.97-1.8,2.41-2.7,4.33-2.7,2.87,0,4.3,1.77,4.3,5.31v8.03Z" />
				<path d="m299.4,236.03c0,1.22-.12,2.3-.36,3.25-.24.94-.59,1.75-1.05,2.41-.46.65-1.03,1.15-1.69,1.5-.67.34-1.42.51-2.28.51s-1.65-.15-2.31-.46v-1.45c.73.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.47-.25.88-.6,1.2-1.07.33-.47.58-1.06.75-1.75.17-.69.26-1.48.26-2.38h-.04c-.57,1.14-1.55,1.71-2.96,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.8-1.31-.19-.51-.29-1.06-.29-1.67,0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.4.38-.39.83-.7,1.35-.92.52-.22,1.09-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.3,1.17.35.51.62,1.14.8,1.9s.28,1.61.28,2.58Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.02.22c-.31.14-.59.35-.82.61-.23.26-.41.57-.55.93-.13.36-.19.75-.19,1.17,0,.47.06.89.19,1.26.13.37.31.68.55.94.23.25.51.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.59-.31.81-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="301.85" y="230.19" width="1.34" height="4.14" />
				<path d="m311.34,243.46h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Zm12.97-6.69c0,1.11-.1,2.09-.31,2.95-.2.86-.49,1.58-.87,2.17-.38.59-.84,1.03-1.4,1.34-.55.3-1.17.45-1.88.45-.67,0-1.26-.14-1.79-.43-.52-.3-.96-.72-1.31-1.29-.36-.56-.63-1.25-.81-2.06-.19-.82-.28-1.76-.28-2.81,0-1.16.1-2.18.29-3.07.2-.89.48-1.63.86-2.23.38-.6.84-1.06,1.4-1.36.56-.31,1.2-.46,1.92-.46,2.78,0,4.17,2.27,4.17,6.8Zm-1.55.15c0-3.77-.9-5.66-2.69-5.66-1.89,0-2.84,1.92-2.84,5.76,0,3.58.93,5.38,2.78,5.38s2.75-1.83,2.75-5.48Z" />
				<path d="m327.95,230.19v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m346.2,233.98l-3.18,4.79,3.13,4.68h-1.77l-1.86-3.07c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.43.72l-1.9,3.07h-1.75l3.23-4.64-3.09-4.83h1.77l1.83,3.24c.14.24.27.49.4.74h.04l2.37-3.98h1.67Z" />
				<path d="m360.93,236.03c0,1.22-.12,2.3-.36,3.25-.24.94-.59,1.75-1.05,2.41-.46.65-1.03,1.15-1.69,1.5-.67.34-1.42.51-2.28.51s-1.65-.15-2.31-.46v-1.45c.73.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.47-.25.88-.6,1.2-1.07.33-.47.58-1.06.75-1.75.17-.69.26-1.48.26-2.38h-.04c-.57,1.14-1.55,1.71-2.96,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.8-1.31s-.29-1.06-.29-1.67c0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.4.38-.39.83-.7,1.35-.92.52-.22,1.09-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.3,1.17.35.51.62,1.14.8,1.9.19.75.28,1.61.28,2.58Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.07-.23-.3-.52-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.02.22c-.31.14-.59.35-.82.61-.23.26-.41.57-.55.93-.13.36-.19.75-.19,1.17,0,.47.06.89.19,1.26.13.37.31.68.55.94.23.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.59-.31.81-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="363.38" y="230.19" width="1.34" height="4.14" />
				<path d="m372.86,243.46h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Zm12.97-6.69c0,1.11-.1,2.09-.31,2.95-.2.86-.49,1.58-.87,2.17-.38.59-.84,1.03-1.4,1.34-.55.3-1.17.45-1.88.45-.67,0-1.26-.14-1.79-.43-.52-.3-.96-.72-1.31-1.29-.36-.56-.63-1.25-.81-2.06-.19-.82-.28-1.76-.28-2.81,0-1.16.1-2.18.29-3.07.2-.89.48-1.63.86-2.23.38-.6.84-1.06,1.4-1.36.56-.31,1.2-.46,1.92-.46,2.78,0,4.17,2.27,4.17,6.8Zm-1.55.15c0-3.77-.9-5.66-2.69-5.66-1.89,0-2.84,1.92-2.84,5.76,0,3.58.93,5.38,2.78,5.38s2.75-1.83,2.75-5.48Z" />
				<path d="m389.48,230.19v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m635.51,751.67h-2.98l-7.05-8.35c-.26-.31-.42-.53-.48-.64h-.05v8.98h-2.14v-18.25h2.14v8.58h.05c.12-.19.28-.39.48-.62l6.82-7.95h2.66l-7.82,8.75,8.37,9.49Zm3.19-16.34c-.37,0-.69-.13-.95-.38s-.39-.58-.39-.97.13-.71.39-.97c.26-.26.58-.39.95-.39s.7.13.97.39c.27.25.41.58.41.97s-.14.69-.41.95c-.26.26-.59.39-.97.39Zm1.02,16.34h-2.09v-13.03h2.09v13.03Zm10.25-.13c-.49.27-1.14.41-1.95.41-2.28,0-3.42-1.27-3.42-3.82v-7.71h-2.24v-1.78h2.24v-3.18l2.09-.67v3.86h3.28v1.78h-3.28v7.34c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm11.65-.47c-1,.6-2.19.9-3.56.9-1.86,0-3.36-.6-4.5-1.81-1.14-1.21-1.7-2.78-1.7-4.71,0-2.15.61-3.87,1.84-5.17,1.23-1.31,2.87-1.96,4.92-1.96,1.15,0,2.15.21,3.03.64v2.14c-.97-.68-2-1.02-3.1-1.02-1.33,0-2.43.48-3.28,1.44-.85.95-1.27,2.2-1.27,3.75s.4,2.73,1.2,3.61c.81.88,1.88,1.32,3.23,1.32,1.14,0,2.21-.38,3.21-1.13v1.98Zm13.96.6h-2.09v-7.51c0-2.71-1.01-4.07-3.03-4.07-1.02,0-1.87.39-2.57,1.18-.7.78-1.04,1.79-1.04,3.02v7.38h-2.09v-19.29h2.09v8.42h.05c1-1.65,2.43-2.47,4.28-2.47,2.93,0,4.4,1.77,4.4,5.31v8.03Zm14.39-5.99h-9.2c.03,1.45.42,2.57,1.17,3.36.75.79,1.77,1.18,3.08,1.18,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.54,1.25s-3.29-.59-4.34-1.77c-1.05-1.19-1.58-2.85-1.58-5,0-2.03.57-3.68,1.72-4.95,1.15-1.28,2.58-1.92,4.29-1.92s3.02.55,3.96,1.65,1.4,2.63,1.4,4.59v1.09Zm-2.14-1.77c0-1.2-.3-2.14-.88-2.81-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.7-1.11,1.62-1.27,2.76h7.04Zm16.09,7.76h-2.09v-7.43c0-2.77-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.6,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.03h2.09v2.16h.05c.98-1.65,2.41-2.47,4.28-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Z" />
				<path d="m313.17,874.26l-3.04,10.78h-1.48l-2.22-7.88c-.1-.34-.15-.7-.17-1.1h-.03c-.03.37-.1.73-.2,1.08l-2.23,7.89h-1.47l-3.16-10.78h1.39l2.29,8.27c.1.35.16.71.18,1.08h.04c.03-.27.1-.63.23-1.08l2.38-8.27h1.21l2.28,8.33c.08.29.14.62.18,1.01h.03c.02-.26.09-.61.2-1.04l2.2-8.3h1.37Z" />
				<polygon points="319.46 874.26 314.29 886.82 313.14 886.82 318.29 874.26 319.46 874.26" />
				<path d="m320.71,885.04v-10.78h2.98c3.8,0,5.7,1.75,5.7,5.25,0,1.66-.53,3-1.59,4.01-1.05,1.01-2.46,1.51-4.23,1.51h-2.86Zm1.26-9.64v8.49h1.61c1.41,0,2.51-.38,3.3-1.13s1.18-1.83,1.18-3.22c0-2.76-1.47-4.14-4.4-4.14h-1.68Z" />
			</g>
		</g>
	)
}

export default PlanT
